<template>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> 订单页轮播图
            </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="container">
            <div class="next-box">
                <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
            </div>
            <el-row>
                <el-col :span="12">         
                <el-table
                style="width:650px"
                    :data="piclist"
                    border
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                   
                >
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                    <el-table-column prop="order_img" label="轮播图"  align="center">
                                <template slot-scope="scope">
                                <el-image
                                    class="table-td-thumb"
                                    :src="scope.row.order_img"
                                    :preview-src-list="[scope.row.order_img]"
                                ></el-image>
                            </template>
                    </el-table-column>
                    <el-table-column label="操作" width="300" align="center">
                        <template slot-scope="scope">
                        
                            <el-button
                                type="text"
                                icon="el-icon-delete"
                                class="red"
                                @click="handleDelete(scope.$index, scope.row)"
                                v-if="$store.state.roleid!=5"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table></el-col>
                <el-col :span="12">
                    <h2>小程序端订单页轮播图效果:</h2>
                    <el-carousel :interval="5000" arrow="always" style="width:690px;height:360px">
                    <el-carousel-item v-for="item in piclist" :key="item.id">
                        <img :src="item.order_img" class="pic" >
                    </el-carousel-item>
                </el-carousel></el-col>
            </el-row>
        </div>
        <!-- 添加弹出框 -->
        <el-dialog title="添加轮播图" :visible.sync="addVisiable" width="600px">
            <el-upload
                action="http://localhost:9999/cat/adopt/insertAdopt"
                ref="uploadimg"
                list-type="picture-card"
                :limit="limit"
                :auto-upload="false"
                :file-list="fileList"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :http-request="uploadFile"
                :on-exceed="exceed">
                <i class="el-icon-plus"></i>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
       
   
</template>
<script>
import {post,get} from '../../../api/request.js'
export default {
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    data(){
        return{
            img:[],
            fileList:[],
            formDate:'',
            limit:0,
            addVisiable:false,
            companyid:'',
            piclist:[],
            htList:[]
        }
    },
    methods:{
        exceed(){
            this.$message.error("轮播图总数上限为五张，请先删除其他图片")
        },
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    formdata.append('order_img',row.order_img)
                    post('admin/set/dorderimg',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()   
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        getData(){
            let formdata = new FormData()
            formdata.append("company_id",this.companyid)
            post("admin/set/sorderimg",formdata).then(res=>{
                this.piclist = res.data.data
                this.limit = parseInt(5-this.piclist.length)
                console.log(this.limit)
                if(this.limit<1){
                    this.limit =0.5
                }
            })
        },
        addData(formName){
            this.formDate = new FormData()
            this.formDate.append("company_id",this.companyid)
            this.$refs.uploadimg.submit();
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            post("admin/set/iorderimg", this.formDate,config).then( res => {
                if(res.data.msg =="添加成功"){
                    this.addVisiable =false
                    this.$message.success("添加成功")
                    this.img= this.htList
                    this.fileList=this.htList
                    this.htList=[]
                    this.getData()
                }
            })
        },
        submitUpload(params) {
            this.proModle.append('file[]',params.file)
        },
        removeImage(file, fileList){
            const tmp_path  = file.response
            if(fileList.length < 1) {
                 this.uploadDisabled = true //未选择文件则禁用上传按钮
             }
        
        },
        handleChange (file, fileList) {
            this.img = fileList;
        },
        handleRemove(file, fileList) {
            this.img = fileList;
        },
        uploadFile(file){
            this.formDate.append('file[]', file.file);
        },
    }
}
</script>
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 360px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .pic{
      width: 690px;
      height: 360px;
  }
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>